import * as R from 'ramda';
import { createSelector } from 'reselect';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// report-common
import { getReportSelectors } from '../../report-common';
//////////////////////////////////////////////////

const {
  store,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectListLoading,
  makeSelectPageVisited,
  makeSelectReportStatus,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
} = getReportSelectors('compensationGroup');

const makeSelectDriverGuid = () => createSelector(
  store,
  ({ driverGuid }) => driverGuid,
);

const makeSelectVendorGuid = () => createSelector(
  store,
  ({ vendorGuid }) => vendorGuid,
);

const makeSelectBranchConfigs = createSelector(
  store,
  ({ branchConfigs }) => branchConfigs,
);

const makeSelectCompensationGroupByGroupGuid = createSelector(
  [
    R.path(['compensationGroup', 'itemList']),
    (_, guid) => guid,
  ],
  (itemList, guid = []) => {
    const item = R.prop(guid, itemList);

    if (R.isNil(item)) return {};

    return {
      ...item,
      compensations: R.map(
        (item) => R.assoc(GC.FIELD_ID, G.generateShortId(), item),
        R.propOr([], 'compensations', item),
      ),
    };
  },
);

const makeSelectItemList = createSelector(
  store,
  R.compose(R.sortBy(R.prop('index')), R.values, R.prop('itemList')),
);

const makeSelectItemListGuids = createSelector(
  store,
  R.compose(R.values, R.map(R.prop(GC.FIELD_GUID)), R.propOr([], 'itemList')),
);

export {
  makeSelectItemList,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectDriverGuid,
  makeSelectVendorGuid,
  makeSelectTotalCount,
  makeSelectListLoading,
  makeSelectPageVisited,
  makeSelectReportStatus,
  makeSelectItemListGuids,
  makeSelectBranchConfigs,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
  makeSelectCompensationGroupByGroupGuid,
};
